/**
 * Enum representing the different modes for handling recurring event deletions
 * Used when deleting recurring events to specify which occurrences should be affected
 */
export enum RecurrenceModificationMode {
  THIS = "this",
  FUTURE = "future",
  ALL = "all",
}
